const brandCatigory = [
  { id: "1", name: "Feron", slug: "feron" },
  { id: "2", name: "Ardero", slug: "ardero" },
  { id: "3", name: "Ledcoin", slug: "ledcoin" },
];

export { brandCatigory };
